export default {
  'content-container-fluid': {
    label: 'Full width container',
    type: 'toggle',
    category: 'Structure'
  },
  'content-container-size': {
    label: 'Container size',
    type: 'radio',
    showOn: {
      field: 'content-container-fluid',
      operator: '==',
      value: '0'
    },
    options: [
      { value: 'sm', text: 'Small' },
      { value: 'md', text: 'Medium' },
      { value: 'lg', text: 'Large' },
      { value: 'xl', text: 'Extra large' }
    ],
    category: 'Structure'
  },
  'content-horizontal-alignment': {
    label: 'Content horizontal alignment',
    type: 'radio',
    options: [
      { value: 'start', text: 'Left' },
      { value: 'center', text: 'Center' },
      { value: 'end', text: 'Right' }
    ],
    category: 'Structure'
  },
  'content-justify': {
    label: 'Content justify',
    type: 'radio',
    options: [
      { value: 'start', text: 'Left' },
      { value: 'center', text: 'Center' },
      { value: 'end', text: 'Right' }
    ],
    category: 'Structure'
  }
}
